// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1qvio","header":"MessagesList_header__3Ybzp","chat":"MessagesList_chat__Z4XM3"};